export default "__VITE_ASSET__c5fb432f__"